module.exports = __webpack_public_path__ + "img/ic-receipt.319f5bf7.png";